var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-detail-field-2"},[_c('span',{staticClass:"kpt-detail-field-label has-text-black-ter has-text-weight-semibold"},[_vm._t("label"),_c('span',{staticClass:"kpt-detail-field-line"})],2),_c('span',{staticClass:"kpt-detail-field-value"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }